
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V10H21C21.5523 10 22 10.4477 22 11V12.8096C20.8321 11.6888 19.2465 11 17.5 11C13.9101 11 11 13.9101 11 17.5C11 19.2465 11.6888 20.8321 12.8096 22H3C2.44772 22 2 21.5523 2 21V11C2 10.4477 2.44772 10 3 10H15V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7V9H7V7Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15.7911 17.0646C15.7911 16.3613 16.3613 15.7911 17.0646 15.7911C17.768 15.7911 18.3381 16.3613 18.3381 17.0646C18.3381 17.768 17.768 18.3381 17.0646 18.3381C16.3613 18.3381 15.7911 17.768 15.7911 17.0646ZM17.0646 14.2911C15.5329 14.2911 14.2911 15.5329 14.2911 17.0646C14.2911 18.5964 15.5329 19.8381 17.0646 19.8381C17.5807 19.8381 18.0639 19.6972 18.4777 19.4516L19.5081 20.482L21.6544 22.6282L22.715 21.5676L21.0991 19.9517L21.9996 19.0512L20.939 17.9905L20.0385 18.891L19.5141 18.3667C19.7209 17.9784 19.8381 17.5352 19.8381 17.0646C19.8381 15.5329 18.5964 14.2911 17.0646 14.2911Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowsecretkeyFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
